/**
 * Holographic tilt driver — binds every [data-plx-holo] element.
 *
 * Pointer position over the element is normalized and eased (rAF lerp) into
 * four CSS custom properties the element's stylesheet consumes:
 *   --hrx / --hry  tilt in degrees (rotateX / rotateY)
 *   --hmx / --hmy  pointer position in % (glare/sheen anchor)
 *   --hact         1 while the pointer is over the card, 0 at rest
 * Ported technique (vanilla) from the godui holographic-card. Reusable: any
 * card that adds the attribute + consumes the vars gets the effect.
 *
 * No listeners are bound on touch-only devices or under reduced motion — the
 * card simply renders static.
 */
(function () {
  var MAX_TILT = 6; // degrees at the card edges
  var EASE = 0.14; // lerp factor per frame

  function bind(el) {
    var cur = { rx: 0, ry: 0, mx: 50, my: 50 };
    var target = { rx: 0, ry: 0, mx: 50, my: 50 };
    var raf = null;

    function tick() {
      raf = null;
      var done = true;
      for (var k in target) {
        cur[k] += (target[k] - cur[k]) * EASE;
        if (Math.abs(target[k] - cur[k]) > 0.05) done = false;
        else cur[k] = target[k];
      }
      el.style.setProperty("--hrx", cur.rx.toFixed(2));
      el.style.setProperty("--hry", cur.ry.toFixed(2));
      el.style.setProperty("--hmx", cur.mx.toFixed(2));
      el.style.setProperty("--hmy", cur.my.toFixed(2));
      if (!done) raf = window.requestAnimationFrame(tick);
    }
    function schedule() {
      if (!raf) raf = window.requestAnimationFrame(tick);
    }

    el.addEventListener("pointerenter", function () {
      el.style.setProperty("--hact", "1");
    });
    el.addEventListener("pointermove", function (e) {
      var r = el.getBoundingClientRect();
      var nx = (e.clientX - r.left) / Math.max(1, r.width) - 0.5; // -0.5..0.5
      var ny = (e.clientY - r.top) / Math.max(1, r.height) - 0.5;
      target.ry = nx * MAX_TILT * 2;
      target.rx = -ny * MAX_TILT * 2;
      target.mx = (nx + 0.5) * 100;
      target.my = (ny + 0.5) * 100;
      schedule();
    });
    el.addEventListener("pointerleave", function () {
      el.style.setProperty("--hact", "0");
      target.rx = 0;
      target.ry = 0;
      target.mx = 50;
      target.my = 50;
      schedule();
    });
  }

  function init() {
    var fine = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || reduce) return;
    var els = document.querySelectorAll("[data-plx-holo]");
    for (var i = 0; i < els.length; i++) bind(els[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
